<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
      <div class="container-fluid w-100"  style="overflow: hidden; min-height: 80vh">
        <navbar :title="$t('material_reports.menu_title')"/>
        <material-report-search
            class="mt-2"
            @search="fetchMaterialReports"
        />

        <!-- Summary -->
        <div v-if="results.length > 0" class="col-12 my-2">
            <contract-material-summary
                :results="results"
                @show-add-material-report="showAddMaterialReportModal"
                @download-material-report-excel="downloadReportExcel"
            />
        </div>

        <material-report-list
            class="pl-3 pr-3 mb-2"
            v-if="results.length > 0"
            :results="results"
            :isObserver="isObserver"
            @edit-report="editReport"/>
        <base-modal v-if="materialReport !== null" size="lg" hide-footer hide-header @close="materialReport = null">
            <contract-material-report-editor
                :material-report="materialReport"
                @emit-add-material-report="submitMaterialReport"
                @close="materialReport = null"
            />
        </base-modal>
        <div v-if="loading > 0" id="loader" class="spinner"/>
    </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {timeUtils} from '@/components/mixins/TimeUtils'
import {downloadHelper} from '@/components/mixins/DownloadMixin'
import MaterialReportList from "@/components/materials/report/MaterialReportList";
import MaterialReportSearch from "@/components/materials/report/MaterialReportSearch";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";
import ContractMaterialReportEditor from "@/components/contractreport/ContractMaterialReportEditor";
import BaseModal from "@/components/BaseModal";
import ContractMaterialSummary from "@/components/contractreport/ContractMaterialSummary";
import {materialReportHelper} from "@/components/mixins/MaterialReportMixin";

export default {
    name: 'MaterialReports',
    components: {
        ContractMaterialSummary,
        BaseModal,
        ContractMaterialReportEditor,
        Navbar,
        MaterialReportSearch,
        MaterialReportList
    },
    mixins: [timeUtils, downloadHelper, restApi, materialReportHelper],
    props: {
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: 0,
            contracts: [],
            results: [],
            materialReport: null
        }
    },
    methods: {
        fetchMaterialReports: function (params) {
            this.loading++
            this.results = []
            if (!params) {
                params = {}
            }
            this.lastSearchParams = params
            this.restFetchParams(this.materialReportUrl, this.lastSearchParams, this.fetchMaterialReportsSuccess, this.fetchFail)
        },
        fetchMaterialReportsSuccess: function (response) {
            this.results = response.data
            this.loading--
        },
        fetchFail: function () {
            this.loading--
        },
        update: function () {
            this.showMaterialReportList()
            this.fetchMaterialReports(this.lastSearchParams)
        },
        editReport: function (report) {
            this.materialReport = report
        },
        showMaterialReportList: function () {
            this.materialReport = null
        },
        downloadReportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.materialReportExcelUrl,
                this.getCommonReportParams(this.lastSearchParams),
                this.downloadSuccess,
                this.downloadFail)
        },
        downloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('material_reports.file_name'))
        },
        downloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
        submitMaterialReport(item) {
            let jsonMaterialReport = this.setDefaultValues(item)
            if(jsonMaterialReport !== undefined) {
                this.loading = true
                if (jsonMaterialReport.id < 0) {
                    this.restAdd(this.simpleMaterialReportUrl, jsonMaterialReport, this.handleMaterialReportResponse, this.fail)
                } else {
                    this.restUpdate(this.simpleMaterialReportUrl, jsonMaterialReport, this.handleMaterialReportResponse, this.fail)
                }
            }
        },
        handleMaterialReportResponse: function (response) {
            if (response) {
                this.loading = false
                this.materialReport = null
                this.update()
            }
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        setDefaultValues: function (value) {
            let materialReport = JSON.parse(JSON.stringify(value))
            if (materialReport.material === '') {
                this.showAlert(this.$t('material_reports.invalid_material'))
                return undefined
            }
            if(materialReport.reporting_date) {
                materialReport.reporting_date = materialReport.reporting_date
            }
            if (materialReport.unit === '') {
                this.showAlert(this.$t('pricing_model_conversion.invalid_unit'))
                return undefined
            }

            if (materialReport.info === null || materialReport.info === '') {
                this.showAlert(this.$t('material_reports.info_missing'))
                return undefined
            }

            materialReport.consumption_records = [{
                id: materialReport.record_id && materialReport.record_id,
                material: materialReport.material,
                amount: materialReport.amount,
                unit: materialReport.unit,
                info: materialReport.info,
            }]
            return materialReport
        },
        showAddMaterialReportModal() {
            this.materialReport = this.getSimpleMaterialReport()
        }
    }
}
</script>
